package ru.malygin.myConst

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import ru.malygin.dto.FindTeachersItemDto
import ru.malygin.dto.MainScheduleItemDto

sealed class ConverterReturnedState(
    val data: List<MainScheduleItemDto>? = null,
    val error: Throwable? = null,
)
{
    class Success(
        data: List<MainScheduleItemDto>,
    ): ConverterReturnedState(
        data = data
    )

    class Error(
        error: Throwable
    ): ConverterReturnedState(
        error = error
    )
}

sealed class DataWorkerState(
    val message: String? = null,
    val error: Exception? = null,
    val newSettingsInfo: SettingsInfo? = null,
)
{
    class Success(
        message: String?,
        newSettingsInfo: SettingsInfo?
    ): DataWorkerState(
        message = message,
        newSettingsInfo = newSettingsInfo
    )

    class Error(
        message: String? = "Error",
        error: Exception
    ): DataWorkerState(
        message = message,
        error = error
    )
}

@Serializable
sealed class ApiReturns{

    @Serializable
    @SerialName("success")
    data class Success(
        val data: List<MainScheduleItemDto>,
    ):ApiReturns()

    @Serializable
    @SerialName("success_schedule_change")
    data class SuccessForScheduleChange(
        val data: List<ScheduleChange>,
    ):ApiReturns()

    @Serializable
    @SerialName("success_find_teacher")
    data class SuccessForFindTeacher(
        val data: List<FindTeachersItemDto>,
    ):ApiReturns()

    @Serializable
    @SerialName("error")
    data class Error(
        val code: ErrorCode,
        val errorMessage: String,
    ):ApiReturns()
}

fun ApiReturns.toParserString(): String{
    return Json.encodeToString<ApiReturns>(
        value = this
    )
}

fun String.toApiReturns(): ApiReturns{
    return Json.decodeFromString<ApiReturns>(
        this
    )
}

fun String.toApiReturnsOr(): ApiReturns{
    val xd = try {
        Json.decodeFromString<ApiReturns>(
            this
        )
    }catch (e: Exception){
        ApiReturns.Error(
            code = ErrorCode.JSON_CONVERTER_ERROR,
            errorMessage = "${e.message}"
        )
    }

    return xd
}

@Serializable
sealed class TeacherPlaces{

    @Serializable
    @SerialName("before")
    data class Before(
        val beforeId: Int,
    ):TeacherPlaces()

    @Serializable
    @SerialName("after")
    data class After(
        val afterId: Int,
    ):TeacherPlaces()

    @Serializable
    @SerialName("between")
    data class Between(
        val beforeId: Int,
        val afterId: Int,
    ):TeacherPlaces()

    @Serializable
    @SerialName("in")
    data class In(
        val id: Int,
    ):TeacherPlaces()

    @Serializable
    @SerialName("none")
    data object None:TeacherPlaces()
}